export default "__VITE_ASSET__Cr6kn0eA__"